export default __webpack_public_path__ + "static/media/celular-games.f2f2ce40.png";